module.exports = __webpack_public_path__ + "static/media/assays.dbc33e67.svg";